// თანამშრომლები — logins, cashiers and PINs, the shift history.
export const staff = {
  'staff.page.1': 'მოლარე წაიშალა',
  'staff.page.2': 'თანამშრომლები',
  'staff.page.3': 'შესვლის ანგარიშები · მოლარეები და PIN კოდები · ცვლების ისტორია',
  'staff.page.4': ' მოლარე',
  'staff.page.5': 'მოლარეები',
  'staff.page.6': 'მოლარე არ არის — დაამატე პირველი',
  'staff.page.7': '(გათიშული)',
  'staff.page.8': 'ყველა ფილიალი',
  'staff.page.9': '{name} — მოქმედებები',
  'staff.page.10': 'გათიშვა',
  'staff.page.11': 'ჩართვა',
  'staff.page.12': 'ცვლების ისტორია',
  'staff.page.13': ' ღია',
  'staff.page.15': 'ცვლა ჯერ არ გახსნილა',
  'staff.page.16': '● ღია',
  'staff.page.17': 'სალარო:',
  'staff.page.18': ' გატანა −₾',
  'staff.page.19': ' შეტანა +₾',
  'staff.page.20': 'კალათიდან გაუყიდავად: ',
  'staff.page.24': 'დარჩა ₾',
  'staff.page.25': ' · გაიტანეს ₾',
  'staff.page.salary': ' · ხელფასი ₾',
  'staff.page.late': '{amount} დახურვის შემდეგ შემოვიდა ({n} გაყიდვა)',
  'staff.page.lateRails': 'ნაღდი {cash} · ბარათი {card} · ნისია {credit}',
  'staff.page.30': 'ზუსტი',
  'staff.page.31': 'მიმდინარე',
  'staff.page.33': 'მოლარე',
  'staff.page.34': 'აქტიური',
  'staff.page.35': 'გათიშული',
  'staff.page.36': 'სახელი, PIN, ფილიალი',
  'staff.page.37': 'PIN-ით ცვლას ვეღარ გახსნის',
  'staff.page.38': 'ისევ შეძლებს ცვლის გახსნას',
  'staff.page.39': 'მოლარის წაშლა',
  'staff.page.40': 'ნამდვილად გსურთ წაშლა? ცვლების ისტორია შენარჩუნდება.',
  'staff.tabs.aria': 'თანამშრომლების გვერდები',
  'staff.tabs.people': 'მოლარეები',
  'staff.tabs.access': 'ანგარიშები',
  'staff.tabs.shifts': 'ცვლები',
  'staff.shifts.hint': 'დახურულ ცვლაზე დაჭერით გაიხსნება Z-რეპორტი',
  'staff.acc.1': 'ვერ შეიქმნა',
  'staff.acc.2': '{name} დაემატა — შესვლა: {email}',
  'staff.acc.3': 'ბუღალტრის ანგარიში მზადაა — {email}',
  'staff.acc.4': 'სალაროს ანგარიში მზადაა — {email}',
  'staff.acc.5': 'ვერ წაიშალა',
  'staff.acc.6': 'წვდომა გაუქმდა',
  'staff.acc.7': 'კოპირება ვერ მოხერხდა',
  'staff.acc.8': 'შესვლის ანგარიშები',
  'staff.acc.9': ' ანგარიშის დამატება',
  'staff.acc.16': 'საერთო სალარო',
  'staff.acc.17': 'ერთი შესვლა დახლზე · ადამიანები PIN-ით',
  'staff.acc.18': 'პიროვნული',
  'staff.acc.19': 'ცალკე შესვლა ერთი მოლარისთვის',
  'staff.acc.20': 'ბუღალტერი',
  'staff.acc.21': 'ხედავს ყველა ანგარიშს · ცვლილების გარეშე',
  // 1.67 — the waiter's own phone
  'staff.waiter.title': 'მიმტანი',
  'staff.waiter.sub': 'საკუთარ ტელეფონზე · მაგიდები და შეკვეთები, ფულის გარეშე',
  'staff.waiter.badge': 'მიმტანი',
  'staff.waiter.manage': 'მიმტანის გათიშვა ან წაშლა — „ანგარიშები“ ჩანართზე',
  'staff.acc.22': 'ელფოსტა',
  'staff.acc.23': 'დასახელება',
  'staff.acc.24': 'სახელი',
  'staff.acc.25': 'სალარო 1',
  'staff.acc.26': 'ნინო',
  'staff.acc.27': 'პაროლი',
  'staff.acc.28': 'კოპირება',
  'staff.acc.29': '⚠️ ჩაინიშნე ან დააკოპირე ახლავე — შემდეგ ვეღარსად ნახავ, მხოლოდ შეცვლა შეიძლება.',
  'staff.acc.30': 'PIN კოდი (ცვლის გასახსნელად)',
  'staff.acc.31': 'სხვა',
  'staff.acc.32': '6 ციფრი. ამ კოდით ხსნის ცვლას და ამ სახელით იწერება ჩეკზე — ',
  'staff.acc.33': 'პაროლი და PIN სხვადასხვაა',
  'staff.acc.34': 'ბუღალტერი ხედავს გაყიდვებს, შესყიდვებს, ხარჯებს, მომწოდებლებს, ნისიას და თვითღირებულებას, ჩამოტვირთავს Excel-ს — მაგრამ ',
  'staff.acc.35': 'ვერაფერს ცვლის',
  'staff.acc.36': ': ვერ ყიდის, ვერ ხსნის ცვლას, ვერ ამატებს და ვერ შლის. ამას თავად ბაზა კრძალავს. სალაროს, თანამშრომლებს და პარამეტრებს (პაროლებს) ვერ ხედავს.',
  'staff.acc.37': 'ამ ანგარიშს PIN არ სჭირდება. დახლზე ერთხელ შედი და ',
  'staff.acc.38': 'აღარ გამოხვიდე',
  'staff.acc.39': ' — ცვლას თითოეული თავისი PIN-ით ხსნის. ადამიანები „მოლარეების" ჩანართში დაამატე.',
  'staff.acc.40': 'შექმნა',
  'staff.acc.41': ' იტვირთება…',
  'staff.acc.42': 'ანგარიშები არ არის.',
  'staff.acc.43': '(შენ)',
  'staff.acc.44': 'საერთო სალარო — ცვლას თითოეული თავისი PIN-ით ხსნის',
  'staff.acc.45': 'მფლობელი',
  'staff.acc.46': 'მოლარე',
  'staff.acc.47': 'წვდომის გაუქმება',
  'staff.acc.48': 'წვდომა გაუქმდეს?',
  'staff.acc.49': 'ანგარიში წაიშლება და ეს ადამიანი ვეღარ შევა სისტემაში. მისი ',
  'staff.acc.50': 'გაყიდვები და ცვლები რჩება',
  'staff.acc.51': ' — ისტორია არ იშლება.',
  'staff.acc.52': 'არა',
  'staff.acc.confirmRevoke': 'წვდომის გაუქმება',
  'staff.acc.summary': 'აქ იმართება სისტემაში შესვლა და დამატებითი უფლებები. მოლარის PIN მხოლოდ ცვლისა და გაყიდვის ავტორს განსაზღვრავს — მონაცემებზე წვდომას ანგარიში აკონტროლებს.',
  'staff.acc.steps': 'ანგარიშის დამატების ნაბიჯები',
  'staff.acc.chooseType': 'ვინ ან რა შევა სისტემაში?',
  'staff.acc.chooseTypeHint': 'ჯერ აირჩიე ანგარიშის ტიპი; შემდეგ შეავსებ მხოლოდ მისთვის საჭირო მონაცემებს.',
  'staff.acc.continue': 'გაგრძელება',
  'staff.acc.formHint': 'ანგარიში განსაზღვრავს, რას დაინახავს მომხმარებელი სისტემაში.',
  'staff.acc.loadFailed': 'ანგარიშების სია ვერ ჩაიტვირთა. არსებული ანგარიშები არ შეცვლილა.',
  'staff.acc.retry': 'თავიდან ცდა',
  'staff.cashier.1': 'სახელი სავალდებულოა',
  'staff.cashier.2': 'PIN უნდა იყოს 4-8 ციფრი',
  'staff.cashier.3': 'ახალი PIN უნდა იყოს მინიმუმ 6 ციფრი',
  'staff.cashier.4': 'ფასდაკლების ლიმიტი 0–100% უნდა იყოს',
  'staff.cashier.5': 'მოლარე განახლდა',
  'staff.cashier.6': 'მოლარე დაემატა',
  'staff.cashier.7': 'მოლარის რედაქტირება',
  'staff.cashier.8': 'ახალი მოლარე',
  'staff.cashier.9': 'სახელი ',
  'staff.cashier.10': 'მაგ. ნინო',
  'staff.cashier.11': 'PIN (6–8 ციფრი) ',
  'staff.cashier.12': 'უცვლელი — ან ჩაწერე ახალი',
  'staff.cashier.13': 'მოლარე ამ PIN-ით ხსნის ცვლას',
  'staff.cashier.14': 'მაქს. ფასდაკლება %',
  'staff.cashier.15': 'ლიმიტის გარეშე',
  'staff.cashier.16': 'ცარიელი = ნებისმიერი ფასდაკლება. მაგ. 5 — მეტს სალარო მფლობელის PIN-ს მოსთხოვს.',
  'staff.cashier.17': 'კალათაზე {maxDiscount}%-ზე მეტი ფასდაკლება მფლობელის PIN-ს სჭირდება.',
  'staff.cashier.18': 'ფილიალი',
  'staff.cashier.19': 'ყველა ფილიალი',
  'staff.cashier.20': 'ამ PIN-ით სხვა ფილიალზე ცვლა არ გაიხსნება.',
  'staff.cashier.21': '„ყველა ფილიალი" — PIN ყველგან მუშაობს (მაგ. მფლობელი, რომელიც ორივეგან დგას).',
  'staff.count.1': 'მოლარეც შეძლებს ინვენტარიზაციაში თვლას',
  'staff.count.2': 'ინვენტარიზაციაში თვლის მხოლოდ მფლობელი',
  'staff.count.3': 'მხოლოდ მე',
  'staff.count.4': 'მოლარეს თვლის ეკრანი არ ექნება',
  'staff.count.5': 'მოლარეც დამეხმარება',
  'staff.count.6': 'მოლარე მხოლოდ რაოდენობას ჩაწერს; სხვაობას და ფასს ვერ ნახავს',
  'staff.count.7': 'ვინ ითვლის?',
  'staff.count.8': 'ინვენტარიზაციაში თვლა',
  'staff.count.9': 'მოლარე, თუ ნებას დართავ, ითვლის ტელეფონით — სისტემაში რამდენია და რა ღირს, ვერ ნახავს.',
  'staff.count.10': ' აირჩიე ერთხელ; {changeLater}.',
  'staff.count.later': 'მერე აქვე შეცვლი',
  'staff.page.removedAmount': '₾{amount} ({n}-ჯერ)',
  'staff.page.afterTimes': ' · გადახდის ფანჯრის შემდეგ {n}-ჯერ',
  'staff.page.gapLess': 'გახსნისას ნაკლები ₾{amount}, ვიდრე წინა ცვლამ დატოვა (₾{carried})',
  'staff.page.gapMore': 'გახსნისას მეტი ₾{amount}, ვიდრე წინა ცვლამ დატოვა (₾{carried})',
  'staff.z.open': 'Z-რეპორტი — {name}, {date}',

  // 1.68 (196) — Staff → „მიმტანები": each waiter's numbers (the owner only, the tables switch on)
  'staff.tabs.waiters': 'მიმტანები',
  'staff.waiters.title': 'მიმტანები',
  'staff.waiters.period': 'პერიოდი',
  'staff.waiters.p.shift': 'ეს ცვლა',
  'staff.waiters.p.today': 'დღეს',
  'staff.waiters.p.week': 'ეს კვირა',
  'staff.waiters.p.month': 'ეს თვე',
  'staff.waiters.who': 'მიმტანი',
  'staff.waiters.checks': 'ანგარიში',
  'staff.waiters.guests': 'სტუმარი',
  'staff.waiters.sales': 'გაყიდვა',
  'staff.waiters.service': 'მომსახურება',
  'staff.waiters.till': 'სალარო',
  'staff.waiters.total': 'სულ',
  'staff.waiters.none': 'ამ პერიოდში მაგიდის ანგარიში არ გადახდილა',
  'staff.waiters.noShift': 'ამ ფილიალში ცვლა ჯერ არ გახსნილა',
  'staff.waiters.failed': 'ციფრები ვერ ჩაიტვირთა — სცადე ცოტა ხანში',
  'staff.waiters.returnsNote': 'მოგვიანებით დაბრუნება იმ პერიოდის თანხას ამცირებს, როცა გაყიდვა მოხდა',
} as const
